import { shallow } from 'zustand/shallow'

import { useReportStore } from '@/modules/report/useReportsStore'

export function useChartSalesMonthReport() {
  const { loading, jsonSalesGoal } = useReportStore(
    (state) => ({
      loading: state.loading,
      jsonSalesGoal: state.jsonSalesGoal,
    }),
    shallow,
  )

  const labels = jsonSalesGoal?.metasAno?.map((item) => {
    return item.mes
  })

  const dataValue = jsonSalesGoal?.metasAno?.map((item) => {
    return item.valor
  })

  const dataCoteValue = jsonSalesGoal?.metasAno?.map((item) => {
    return item.valorCota
  })

  const chartData = {
    labels,
    options: {
      responsive: true,
      plugins: {
        legend: {
          position: 'top',
        },
      },
    },
    datasets: [
      {
        label: 'Valor Atual',
        data: dataValue,
        borderColor: 'rgb(84, 227, 142)',
        backgroundColor: 'rgba(84, 227, 142, 0.5)',
      },
      {
        label: 'Valor Cota',
        data: dataCoteValue,
        borderColor: 'rgb(53, 162, 235)',
        backgroundColor: 'rgba(53, 162, 235, 0.5)',
      },
    ],
  }

  return {
    loading,
    jsonSalesGoal,
    chartData,
  }
}
